import * as actions from '../actions/gplPolicyDocuments';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';

const REQUEST_GPL_POLICY_DOCUMENTS = 'requestGplPolicyDocuments';

export function requestGplPolicyDocuments(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.FETCH_GPL_POLICY_DOCUMENTS)
        .map(action => ({
            url: BASE_URL + 'api/gplpolicydocuments',
            category: REQUEST_GPL_POLICY_DOCUMENTS,
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select(REQUEST_GPL_POLICY_DOCUMENTS)
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .map(response => (
            response.status === 200
                ? actions.fetchGplPolicyDocumentsSuccess(response)
                : actions.fetchGplPolicyDocumentsFailed(response)
        ));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

const REQUEST_GPL_POLICY_DOCUMENT_FILE = 'requestGplPolicyDocumentFile';

// Review: this replaces a raw fetch() in gplWordingModal.js. The app routes every other HTTP
// call through the cycle HTTP driver, and bypassing it also meant hand-rolling the 401 handling
// that the driver and the store already do centrally.
//
// action.payload is {slug, kind} where kind is 'wording' or 'ipid'.
export function requestGplPolicyDocumentFile(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.FETCH_GPL_POLICY_DOCUMENT_FILE)
        .map(action => ({
            url: BASE_URL + 'api/gplpolicydocuments/' + action.payload.slug + '/' + action.payload.kind,
            category: REQUEST_GPL_POLICY_DOCUMENT_FILE,
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select(REQUEST_GPL_POLICY_DOCUMENT_FILE)
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .map(response => (
            response.status === 200
                ? actions.fetchGplPolicyDocumentFileSuccess(response)
                : actions.fetchGplPolicyDocumentFileFailed(response)
        ));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}
